'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const getRowBackgroundColor = (isHover = false) => ({ $isFocus, $mode, theme }) => {
    if ($isFocus) {
        return `background-color: ${theme.colors.primary.alpha};`;
    }
    if (isHover) {
        return `background-color: ${theme.colors.hover};`;
    }
    switch ($mode) {
        case 'validated':
            return `background-color: ${theme.colors.table.validated};`;
        case 'added':
        case 'modified':
            return `background-color: ${theme.colors.table.modified};`;
    }
    return null;
};
const ExpandedContainer = styled__default.default.div `
  font-size: ${({ theme }) => theme.typography.fontSize.s};
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  line-height: ${({ theme }) => theme.typography.lineHeight.s};
  letter-spacing: ${({ theme }) => theme.typography.letterSpacing.m};
  color: ${({ theme }) => theme.colors.body.text};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-height: 50vh;
`;
const RowBase = styled__default.default.tr `
  ${getRowBackgroundColor()}
  ${({ $hasExpanded, theme }) => ($hasExpanded ? '' : `border-bottom: 1px solid ${theme.colors.border};`)}

  a {
    color: ${({ theme }) => theme.colors.body.text};
  }

  ${({ $noHover, theme }) => $noHover
    ? null
    : styled.css `
          &:hover {
            ${getRowBackgroundColor(true)}

            a {
              color: ${theme.colors.primary.normal};
            }
          }
        `}

  &:focus {
    background-color: ${({ theme }) => theme.colors.primary.alpha};
  }

  &[aria-expanded='false'] + tr ${ExpandedContainer} {
    max-height: 0;
  }

  ${({ $isEdit, theme }) => $isEdit
    ? `
    position: relative;
    pointer-events: none;

    td:first-child:after {
      content: "";
      background-color: ${theme.colors.table.disable};
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: ${theme.zIndices.tableFilter};
    }
  `
    : null}
`;
const CellPadding = styled__default.default.div `
  padding: ${({ theme }) => `0 ${theme.space.table.l} ${theme.space.table.xl} ${theme.space.table.s}`};
`;

exports.CellPadding = CellPadding;
exports.ExpandedContainer = ExpandedContainer;
exports.RowBase = RowBase;
//# sourceMappingURL=row.styles.js.map
